var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_46_886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_46_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8 22.6L15.6 18.4501C15.0167 18.6334 14.4292 18.7709 13.8375 18.8626C13.2458 18.9542 12.6333 19 12 19C9.48333 19 7.24167 18.3042 5.275 16.9125C3.30833 15.5209 1.88333 13.7167 1 11.5C1.35 10.6167 1.79167 9.79588 2.325 9.03755C2.85833 8.27922 3.46667 7.60005 4.15 7.00005L1.4 4.20005L2.8 2.80005L21.2 21.2001L19.8 22.6ZM12 16C12.1833 16 12.3542 15.9917 12.5125 15.975C12.6708 15.9584 12.8417 15.925 13.025 15.875L7.625 10.475C7.575 10.6584 7.54167 10.8292 7.525 10.9875C7.50833 11.1459 7.5 11.3167 7.5 11.5C7.5 12.75 7.9375 13.8125 8.8125 14.6875C9.6875 15.5625 10.75 16 12 16ZM19.3 16.4501L16.125 13.3C16.2417 13.0167 16.3333 12.7292 16.4 12.4375C16.4667 12.1459 16.5 11.8334 16.5 11.5C16.5 10.25 16.0625 9.18755 15.1875 8.31255C14.3125 7.43755 13.25 7.00005 12 7.00005C11.6667 7.00005 11.3542 7.03338 11.0625 7.10005C10.7708 7.16672 10.4833 7.26672 10.2 7.40005L7.65 4.85005C8.33333 4.56672 9.03333 4.35422 9.75 4.21255C10.4667 4.07088 11.2167 4.00005 12 4.00005C14.5167 4.00005 16.7583 4.69588 18.725 6.08755C20.6917 7.47922 22.1167 9.28338 23 11.5C22.6167 12.4834 22.1125 13.3959 21.4875 14.2375C20.8625 15.0792 20.1333 15.8167 19.3 16.4501ZM14.675 11.85L11.675 8.85005C12.1417 8.76672 12.5708 8.80422 12.9625 8.96255C13.3542 9.12088 13.6917 9.35005 13.975 9.65005C14.2583 9.95005 14.4625 10.2959 14.5875 10.6875C14.7125 11.0792 14.7417 11.4667 14.675 11.85Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility_off.20a5605a436176ccb46e02b1b428edbd.svg";
export { ForwardRef as ReactComponent };